import { supabase } from '../../supabaseClient';


// GET USER SHOPPING LIST
export async function getShoppingList(userId) {

  let { data, error } = await supabase
    .from('shopping_lists')
    .select('*')
    .eq('user_id', userId)
    .limit(1);

  if (error) {
    console.error('Error fetching shopping list:', error);
    return null;
  }

  return data[0] || null;
}

// CREATE SHOPPING LIST
export async function createShoppingList(userId) {
  let { data, error } = await supabase
    .from('shopping_lists')
    .insert([
      {
        user_id: userId,
        name: 'Shopping List'
      }
    ])
    .select()
    .single();

  if (error) {
    console.error('Error creating shopping list:', error);
    return null;
  }

  return data;
}


// GET SHOPPING ITEMS
export async function getShoppingItems(listId) {
  let { data, error } = await supabase
    .from('shopping_items')
    .select('*')
    .eq('shopping_list_id', listId)
    .order('completed', { ascending: true })
    .order('store', { ascending: true })
    .order('created_at', { ascending: true });

  if (error) {
    console.error('Error fetching shopping items:', error);
    return [];
  }

  return data;
}


// ADD SHOPPING ITEM
export async function addShoppingItem(item) {
  let { data, error } = await supabase
    .from('shopping_items')
    .insert([item])
    .select()
    .single();

  if (error) {
    console.error('Error adding shopping item:', error);
    return null;
  }

  return data;
}


// TOGGLE COMPLETED
export async function toggleShoppingItem(id, completed) {
  let { error } = await supabase
    .from('shopping_items')
    .update({
      completed,
      completed_at: completed ? new Date() : null
    })
    .eq('id', id);

  if (error) {
    console.error('Error updating shopping item:', error);
  }
}


// DELETE ITEM
export async function deleteShoppingItem(id) {
  let { error } = await supabase
    .from('shopping_items')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting shopping item:', error);
  }
}

//UPDATE ITEM
export async function updateShoppingItem(id, updates) {

  let { error } = await supabase
    .from('shopping_items')
    .update(updates)
    .eq('id', id);

  if (error) {
    console.error('Error updating shopping item:', error);
  }
}

export async function renameStore(
  listId,
  oldStore,
  newStore
) {

  const { error } = await supabase
    .from('shopping_items')
    .update({
      store: newStore
    })
    .eq('shopping_list_id', listId)
    .eq('store', oldStore);

  if (error) {
    console.error(
      'Error renaming store:',
      error
    );
  }
}

//DELETE STORE NAME
export async function clearStoreName(
  listId,
  storeName
) {

  const { error } = await supabase
    .from('shopping_items')
    .update({
      store: null
    })
    .eq('shopping_list_id', listId)
    .eq('store', storeName);

  if (error) {
    console.error(
      'Error clearing store:',
      error
    );
  }
}

export async function deleteStore(
  listId,
  storeName
) {

  const { error } = await supabase
    .from('shopping_items')
    .update({
      store: null
    })
    .eq('shopping_list_id', listId)
    .eq('store', storeName);

  if (error) {
    console.error(
      'Error deleting store:',
      error
    );
  }
}